// extracted by mini-css-extract-plugin
module.exports = {"card":"Dash_card__3lUDh","title-white":"Dash_title-white__173d6","title-black":"Dash_title-black__2RpiA","textWhite":"Dash_textWhite__1cqkY"};